
function StudyItem(item, target) {
  var properties = [];
  for (let key of Object.keys(item)) {
    let value = item[key];
    let type = getPropertyType(value);
    let property = {
      key,
      value,
      type
    };
    if (type == "imageArray") {
      property.rotate = true;
      property.current = 0;
    } else {
      property.rotate = false;
    }
    properties.push(property);
  }
  properties.target = target;
  this.properties = properties;
  this.id = item.id;
}

StudyItem.prototype.getField = function (name) {
  for (let prop of this.properties) {
    if (prop.key == name) {
      return prop;
    }
  }
  return null;
};

export default StudyItem;

function getPropertyType(property) {
  var value = property;
  var isArray = false;
  if (Array.isArray(value)) {
    if (value.length == 0) {
      return "";
    }
    value = property[0];
    isArray = true;
  }

  var type = getValueType(value);
  if (isArray) {
    type += "Array";
  }
  return type;
}

function getValueType(value) {
  if (/\.(mp3|ogg|wav)/i.exec(value)) {
    return "audio";
  }
  if (/\.(jpg|png|svg|gif|bmp)/i.exec(value)) {
    return "image";
  }
  return "text";
}